<div *ngIf="layout === 'bar' && (visible || showAllControlsVisible || showRange)" class="tt-table-pagination" [ngClass]="wrapperClass">
  <p class="tt-table-pagination__range">řádky {{ formatCount(rangeStart) }}–{{ formatCount(rangeEnd) }} z {{ formatCount(totalItems) }}</p>
  <div class="tt-table-pagination__controls" role="navigation" aria-label="Stránkování">
    <ng-container *ngIf="visible">
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="goToPage(currentPage - 1)"
        [disabled]="currentPage <= 1"
      >
        Předchozí
      </button>
      <ng-container *ngFor="let item of paginationItems">
        <span *ngIf="item === 'ellipsis'" class="tt-table-pagination__ellipsis" aria-hidden="true">…</span>
        <button
          *ngIf="item !== 'ellipsis'"
          type="button"
          (click)="goToPage(item)"
          [attr.aria-current]="item === currentPage ? 'page' : null"
          class="btn btn-sm tt-table-pagination__page"
          [ngClass]="item === currentPage ? 'btn-primary' : 'btn-secondary'"
        >
          {{ item }}
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="goToPage(currentPage + 1)"
        [disabled]="currentPage >= totalPages"
      >
        Další
      </button>
      <div class="tt-table-pagination__jump">
        <input
          #pageJump
          type="number"
          class="tt-filter-control tt-table-pagination__jump-input"
          [attr.min]="1"
          [attr.max]="totalPages"
          [value]="currentPage"
          aria-label="Číslo stránky"
          (keydown.enter)="jumpTo(pageJump.value)"
        />
        <span class="tt-table-pagination__jump-total">/ {{ formatCount(totalPages) }}</span>
        <button type="button" class="btn btn-secondary btn-sm" (click)="jumpTo(pageJump.value)">
          Jít na stránku
        </button>
      </div>
    </ng-container>
    <button
      *ngIf="showAllAction && !showAllActive && totalItems > itemsPerPage"
      type="button"
      class="btn btn-secondary btn-sm"
      [disabled]="showAllLoading"
      (click)="showAllClick.emit()"
    >
      Zobrazit všechny řádky ({{ formatCount(totalItems) }})
    </button>
    <button
      *ngIf="showAllAction && showAllActive"
      type="button"
      class="btn btn-secondary btn-sm"
      [disabled]="showAllLoading"
      (click)="exitShowAllClick.emit()"
    >
      Stránkovat po {{ formatCount(itemsPerPage) }}
    </button>
  </div>
</div>

<div *ngIf="layout !== 'bar' && (visible || showAllControlsVisible)" [ngClass]="wrapperClass" class="pagination mt-6 flex flex-col items-center gap-3">
  <nav *ngIf="visible" class="flex items-center space-x-2" aria-label="Stránkování">
    <button
      type="button"
      (click)="goToPage(currentPage - 1)"
      [disabled]="currentPage <= 1"
      class="btn btn-secondary btn-sm"
      aria-label="Předchozí stránka"
    >
      ‹
    </button>
    <ng-container *ngFor="let item of paginationItems">
      <span *ngIf="item === 'ellipsis'" class="px-1 text-neutral-400" aria-hidden="true">…</span>
      <button
        *ngIf="item !== 'ellipsis'"
        type="button"
        (click)="goToPage(item)"
        [attr.aria-current]="item === currentPage ? 'page' : null"
        class="btn btn-sm"
        [ngClass]="item === currentPage ? 'btn-primary' : 'btn-secondary'"
      >
        {{ item }}
      </button>
    </ng-container>
    <button
      type="button"
      (click)="goToPage(currentPage + 1)"
      [disabled]="currentPage >= totalPages"
      class="btn btn-secondary btn-sm"
      aria-label="Další stránka"
    >
      ›
    </button>
  </nav>

  <div *ngIf="showAllControlsVisible" class="flex flex-col items-center gap-2">
    <app-button
      *ngIf="!showAllActive"
      variant="secondary"
      size="sm"
      [loading]="showAllLoading"
      [disabled]="showAllLoading"
      (onClick)="showAllClick.emit()"
    >
      Zobrazit všechny řádky ({{ totalItems }})
    </app-button>
    <app-button
      *ngIf="showAllActive"
      variant="secondary"
      size="sm"
      [loading]="showAllLoading"
      [disabled]="showAllLoading"
      (onClick)="exitShowAllClick.emit()"
    >
      Stránkovat po {{ itemsPerPage }}
    </app-button>
  </div>
</div>
